import React, { createContext, useReducer, useRef } from "react";
import { toastSuccess, toastError } from "../utils";

import { getService, patchService } from "../services/axios/services";
import { useProjectSheetInvalidation } from "../hooks/useProjectSheetInvalidation";
import sheetReduce from "./sheetAndRegisterReduce";

const initialContext = {
  filter: {},
  list: {
    loading: true,
    result: [],
  },
  plot: {
    loading: true,
    result: [],
  },
  listVarieties: {
    loading: true,
    result: [],
  },
  listResearch: {
    loading: true,
    result: [],
  },
  listLiteraryWorks: {
    loading: true,
    result: [],
  },
  relevances: {
    loading: true,
    result: [],
  },
  characters: {
    loading: true,
    result: [],
    error: false,
  },
  seasons: {
    loading: true,
    result: [],
  },
};

const ProjectSheet = createContext();

const ProjectShettProvider = ({ children }) => {
  const [state, dispatch] = useReducer(sheetReduce, initialContext);
  const currentSheetRef = useRef({
    id: null,
    type: null,
  });

  const compileDataId = (data) => {
    if (!data?.length) return [];

    let i = [];

    if (!!data) {
      data.forEach((el) => {
        i.push(el.value);
      });
    }

    return i;
  };

  const compileProduct = (data) => {
    if (!data?.length) return [];

    let _arrayF = [];
    data.forEach((el) => {
      _arrayF.push(el.id);
    });

    return _arrayF;
  };

  const compileCreators = (creators) => {
    if (!creators?.length) return [];

    let filter = [];

    creators.forEach((el) => {
      if (!!el.label || !!el.name) {
        filter.push({
          creatorId: el.id || el.value,
          origin: el.origin ? el.origin : "Prospect",
        });
      }
    });
    return !!filter.length ? filter : creators;
  };

  const toggleCharacter = (id, bool, dramaturgiaId) => {
    patchService({ endpoint: `dramaturgies/characters/${id}/active/${bool}` })
      .then(() => {
        toastSuccess(
          `Personagem ${bool ? "ativado" : "inativado"} com sucesso`
        );
        _getProjectSheet(dramaturgiaId, "dramaturgies");
      })
      .catch(() => {
        toastError("Algo deu errado");
      });
  };

  const _getProjectSheet = (id, type) => {
    currentSheetRef.current = { id };
    return get(`${type}/${id}`, "list");
  };

  const _getPlotContent = (contentId) => {
    currentSheetRef.current = { id: contentId };
    return get(`plots/contents/${contentId}`, "plot");
  };

  const _getProjectSheetVarieties = (id, type) =>
    get(`${type}/${id}`, "listVarieties");

  const _getProjectSheetResearch = (id, type) =>
    get(`${type}/${id}`, "listResearch");

  const _getProjectSheetLiteraryWorks = (id, type) =>
    get(`${type}/${id}`, "listLiteraryWorks");

  const getRelevances = () =>
    get(`dramaturgies/characters/relevances`, "relevances");

  const getCharacters = async (id) =>
    await get(`dramaturgies/${id}/characters`, "characters").catch((e) => {
      dispatch({ key: "characters", action: "list", payload: { error: true } });
      loading("characters", false);
    });

  const getSeasons = (id) => get(`products/${id}/seasons`, "seasons");

  const loading = (subject, active) => {
    dispatch({ action: "loading", payload: { subject, active } });
  };

  const clearSheet = () =>
    dispatch({ payload: [], key: "list", action: "list" });

  const get = (path, key) => {
    loading(key, true);
    return getService({ endpoint: path })
      .then((result) => {
        dispatch({ payload: result, key: key, action: "list" });
        loading(key, false);
      })
      .catch((e) => {
        if (e.response.status === 504) throw new Error("504");
        dispatch({ key: key, action: "list", payload: { result: "" } });
        loading(key, false);
      });
  };

  const phasesFromTo = (name) => {
    const names = {
      "PÓS PRODUÇÃO": "PÓS-PRODUÇÃO",
      "PRÉ PRODUÇÃO": "PRÉ-PRODUÇÃO",
      "MIGRACAO AGRA": "MIGRAÇÃO AGRA",
    };
    return names[name] || name;
  };

  useProjectSheetInvalidation({
    onInvalidate: () => {
      const { id } = currentSheetRef.current;
      if (!id) return;

      get(`dramaturgies/${id}`, "list");
      get(`plots/contents/${id}`, "plot");
    },
  });

  return (
    <ProjectSheet.Provider
      value={{
        ...state,
        _getProjectSheet,
        _getPlotContent,
        _getProjectSheetVarieties,
        _getProjectSheetResearch,
        _getProjectSheetLiteraryWorks,
        compileDataId,
        compileCreators,
        compileProduct,
        getRelevances,
        getCharacters,
        toggleCharacter,
        getSeasons,
        loading,
        phasesFromTo,
        clearSheet,
      }}
    >
      {children}
    </ProjectSheet.Provider>
  );
};

export { ProjectSheet as default, ProjectShettProvider };
